export function resetApplication(cacheName) {
    if (!cacheName) return;

    flushCache(cacheName);
    window.location.reload();
}

export function flushCache(cacheName) {
    if (!cacheName) return;
    deleteCaches(cacheName);
}


function deleteCaches (dataCacheName) {
    let fileCacheName = `workbox-precache-v2-${window.location.origin}/`;
    
    caches.delete(dataCacheName);
    caches.delete(fileCacheName);
}